import { lotteries, countries } from '~/utils/constants/home.js'
import { ID_EURO_MILLIONS } from '~/utils/constants/idsLotteries.js'
import { ID_PORTUGAL } from '~/utils/constants/idsCountries'

const setCountry = (lotteryId: number) => {
	if (lotteryId === ID_EURO_MILLIONS) {
		return countries.find((c) => c.id === ID_PORTUGAL)
	}
	const country = countries.find((c) => c.lotteries.includes(lotteryId))
	return country
}

const normalizePrize = (value: unknown) => {
	if (typeof value === 'number') return Number.isFinite(value) ? value : null
	if (typeof value === 'string' && value.trim() !== '') {
		const parsed = Number(value)
		return Number.isFinite(parsed) ? parsed : null
	}
	return null
}

/**
 * Merges the notification API response with the static lottery catalogue to produce
 * a display-ready list. Entries with a zero or null prize are filtered out.
 * @param lastLotteries - Raw lottery entries from the notifications API.
 */
export const getLastLotteries = (lastLotteries: any[]) => {
	const safeLastLotteries = Array.isArray(lastLotteries) ? lastLotteries.filter(Boolean) : []

	return lotteries
		.map((lottery) => {
			const match = safeLastLotteries.find((lastLottery) => lastLottery?.id === lottery.id)
			const country = setCountry(lottery.id)
			if (!match) return null

			const latest = latestGame(match.games)
			const prize = normalizePrize(latest?.prize)
			if (prize === null) return null

			return {
				lottery_id: lottery?.id,
				currency: match.currency,
				flag: country?.flag,
				country: country?.label,
				country_id: country?.id,
				name: lottery?.name,
				...latest,
				prize,
			}
		})
		.filter((item: any) => item && item.prize !== 0)
}

/**
 * Returns the most recent game entry from an array, comparing by `date`.
 * Returns `null` if the array is empty or falsy.
 * @param games - Array of game objects with a `date` field.
 */
export const latestGame = (games: any) => {
	if (!games?.length) return null
	if (games?.length === 1) return games[0]
	return games.reduce((latest: any, current: any) => {
		return new Date(current.date) > new Date(latest.date) ? current : latest
	})
}
